import { Component } from '@opten/compiler/metadata/component';
import { Collapse } from '@opten/collapse/initializer';
import { hasClass } from '@opten/dom/has-class';

@Component({ className: 'js-collapse', observe: true })
export class CollapseComponent {
	collapse: Collapse;
	constructor(private element: HTMLElement) {
		this.collapse = new Collapse(element, { closeSiblings: hasClass(element,'js-collapse--single') });
	}
}